<template>
  <section class="prod-grid" :class="gridClass">
    <div v-if="products.length" class="prod-grid__wrap">
        <SingleProduct
          v-for="product in products"
          :key="product.id"
          :product="product"
        />
    </div>
    <NoProducts v-if="!products.length && !isLoading"  />
    <transition name="slide-up-fade" mode="out-in">
      <LoaderComponent v-if="isLoading" />
    </transition>
  </section>
</template>

<script setup lang="ts">
import SingleProduct from "./SingleProduct.vue";
import {useProductStore} from "../../store/product.ts";
import {storeToRefs} from "pinia";
import {onMounted} from "vue";
import LoaderComponent from "./LoaderComponent.vue";
import NoProducts from "./NoProducts.vue";
import {useCategoryStore} from "../../store/category.ts";

const productStore = useProductStore()
const {getProducts } = productStore
const {products, gridClass, isLoading, prodRequest} = storeToRefs(productStore)

const { setName } = useCategoryStore();

function setTittle() {
  const currentUrl = window.location.href
  const url = new URL(currentUrl)
  const params = url.searchParams;
  const searchQuery = params.get('searchQuery');
  if(searchQuery){
    setName(decodeURI(searchQuery).replaceAll(',', ', '));
  }

}

onMounted(()=>{
  getProducts()
  setTittle()
})
</script>
